/*!
 * AudoChat - Password Hashing Utility
 * Uses bcryptjs for password hashing (works in browser)
 */

import bcrypt from 'bcryptjs';

// Hash password
export const hashPassword = async (password) => {
  try {
    const salt = await bcrypt.genSalt(10);
    const hash = await bcrypt.hash(password, salt);
    return hash;
  } catch (error) {
    console.error('Error hashing password:', error);
    throw error;
  }
};

// Compare password with hash
export const comparePassword = async (password, hash) => {
  try {
    const isMatch = await bcrypt.compare(password, hash);
    return isMatch;
  } catch (error) {
    console.error('Error comparing password:', error);
    return false;
  }
};

// Sync version (for compatibility)
export const hashPasswordSync = (password) => {
  try {
    const salt = bcrypt.genSaltSync(10);
    const hash = bcrypt.hashSync(password, salt);
    return hash;
  } catch (error) {
    console.error('Error hashing password:', error);
    throw error;
  }
};

export const comparePasswordSync = (password, hash) => {
  try {
    return bcrypt.compareSync(password, hash);
  } catch (error) {
    console.error('Error comparing password:', error);
    return false;
  }
};

